<div [style.width]="width() ?? '100px'" [style.height]="height() ?? '100px'" [class.just-logo--framed]="framed()">
  <svg [attr.stroke]="resolvedColor()"
       [style.stroke]="resolvedColor()"
       [attr.fill]="resolvedColor()"
       [style.fill]="resolvedColor()" viewBox="0 0 54.27 24.9" preserveAspectRatio="xMidYMid meet">
    <g id="Calque_2" data-name="Calque 2">
      <g id="Calque_1-2" data-name="Calque 1">
        <path class="cls-1"
              d="M27.14,24.76A27.21,27.21,0,0,1,.16,1.2L0,0H14.25l.2.8a13,13,0,0,0,12.69,9.89A13,13,0,0,0,39.82.8L40,0H54.27l-.15,1.2A27.23,27.23,0,0,1,27.14,24.76Z"/>
        @if (!simple()) {
          <path class="cls-1"
                d="M27.14,24.88A27.34,27.34,0,0,1,0,0H14.25C16.48,14,37.8,14,40,0H54.27A27.34,27.34,0,0,1,27.14,24.88Z"/>
        }
      </g>
    </g>
  </svg>
</div>
